"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendedSubscriptionResponseModelCharacterRefreshPeriod = void 0;
exports.ExtendedSubscriptionResponseModelCharacterRefreshPeriod = {
    MonthlyPeriod: "monthly_period",
    AnnualPeriod: "annual_period",
};
